import chroma from "chroma-js";
import stylesConfig from "../styles.config";
import globals from "../partials/global-variables";

export default {
  container: {
    "& .navigation-steps": {
      display: "block",
      position: "relative",
      top: "15px",
      textAlign: "center",
      fontSize: stylesConfig.typography.fontSize(1),
      fontWeight: 400,
      color: `${chroma(globals.colors.contrastDark).alpha(0.8)}`,
      letterSpacing: ".5px",
      [`@media (${globals.breakpoints.$xs})`]: {
        fontSize: stylesConfig.typography.fontSize(0.875),
        letterSpacing: ".44px",
        lineHeight: "1.2em",
      },
    },
    "& .inner-box": {
      padding: "30px",
      paddingTop: 0,
      "& .toLeft": {
        justifyContent: "start",
      },
      "& .toCenter": {
        justifyContent: "center",
      },
      [`@media (${globals.breakpoints.$xs})`]: {
        padding: "0 10px 10px",
      },
    },
  },
};
